import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'BASE_DATA_EXPORT_COUNTRY',
    icon: 'menu-export-country',
    label: '出口国',
    path: '/base-data/export-country',
  },
] satisfies Menu[];
